export const BASE_URL = "https://apisaiaquapets.saihustlehub.com/api/";

export const URL = {
    login: "send-otp",
    verify: "verify-otp",
    register: "register",
    resendotp: "resent-otp",
    PRODUCT_LIST: "products/products",
    CATEGORY_LIST: 'categories/list',
    POPULAR_PRODUCT: "popularproducts/popular",
    viewpopular: "products/product",
    logout: "logout",
    cart: "cart",
    Deletecart: "cart",
    cartview: "cart",
    whishlist: "whishlist/add",
    viewishlist: "whishlist",
    removewishlist: "whishlist",
    Address: "address/add",
    ViewAddress: "address/all",
    EditAddress: "address/",
    GetTopsell: "products/topselling",
    orderpost: "orders",
    Personalprofile: "personal/personalregister",
    Personalget: "personal/personalusers",
    profileedit: "personal/personalupdate",
    profiledelete: "personal/personaldelete",
    orderconfirm: "confirmorders/confirm",
    orderget:"confirmorders/order",
    getallorder:"confirmorders/all",
    cancelorder:"confirmorders/delete",
    SEARCH: "products/search",
  }
export const TOKEN = "token"  